export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9266.db1c4aae.jpg";